import { toast } from 'react-toastify';

export function toastSuccess(message: string) {
  if (message) {
    return toast.success(message);
  }
}

export function toastInfo(message: string) {
  if (message) {
    return toast.info(message);
  }
}

export function toastWarning(message: string) {
  if (message) {
    return toast.warn(message);
  }
}

export function toastError(error: any) {
  let toastData = '';
  if (typeof error === 'string') {
    toastData = error;
  } else if (typeof error === 'object' && error.message) {
    toastData = error.message;
  } else if (error && error instanceof Array) {
    toastData = error.join(', ');
  }
  if (toastData && typeof toastData === 'string' && toastData !== '') {
    toast.error(toastData);
  }
}
